import {Exclude, Expose} from 'class-transformer';
import {EntitySerialization} from './entity-serialization';

@Exclude()
export class BaseEntity extends EntitySerialization {

  @Expose()
  public id?: string;
}
